import { LanguagePackageType } from "@/typeDefine/EntityType"
import companyImage2 from '@/assets/images/companyImage2.png'
import companyImage3 from '@/assets/images/companyImage3.jpg'

const En: LanguagePackageType = {
    //首页
    index: {
        //顶部导航
        navBar: {
            home: 'Home',
            aboutUs: 'About Us',
            product: 'Products',
            news: 'News',
            contactUs: 'Contact Us',
            newsDetails: 'News Details',
            productDetails: 'product details'
        },

        //公司介绍
        companyProfile: {
            title: "Odin's global cooperation",
            introduce: 'Odin Motor Company was founded in China. After more than 20 years of development, the company has grown into a professional small household appliance motor custom manufacturer. We focus on the research and development, production, installation and debugging of small household appliance motors and solution provision. The main products are AC motors, induction motors, DC motors, BLDC motors, etc. Our motors have been successfully exported to more than 20 countries and regions, and we have established long-term cooperative relations with many companies. Welcome to join or establish cooperation with "Odin".'
        },
        hotSales: {
            title: 'Hot-Selling Products',
            tips: 'As a company with more than twenty years of experience in motors, we provide a variety of products for different customers around the world. We have our own factory, complete production line and engineer team dedicated to serving every customer and providing customers with high-quality products.',
            lookMoreButtonText: 'View More Products'
        },
        floatButton: {
            popoverTitle: 'Contact Details'
        },
        advantage: [
            {
                top: '20+',
                bottom: 'years of experience'
            },
            {
                top: '15000+',
                bottom: 'area production base'
            },
            {
                top: '1000+',
                bottom: 'enterprise employees'
            },
            {
                top: '100+',
                bottom: 'cooperative customers'
            }
        ],
        chooseUs: {
            title: 'Why Choose Us',
            tips: '',
            chooseItem: [
                {
                    title: 'What do we do?',
                    tips: '1.Provide motors for household appliances such as electric fans, blenders, juicers, toasters, electric toys, robots, etc.\n2.Various motors, materials, power, voltage, etc. can be customized according to requirements.\n3.Sample fee is used as a discount in the transaction order.'
                },
                {
                    title: 'How do we do?',
                    tips: '1.Four factories, including more than 1500 workers, can produce 10 million engines per year.\n2.After receiving the sample, we can provide the product for testing within 7-15 working days.\n3.After receiving the drawing, we can provide the sample within 7-15 working days.'
                },
                {
                    title: 'What can you get?',
                    tips: '1.Competitive price and stable quality, the product is always the same as the sample.\n2.Quick response, professional communication.\n3.Fastest delivery within the specified time. We have our own factory and can make adjustments in case of emergency.'
                }
            ]
        },
        footer: {
            product: {
                title: 'product'
            },
            aboutUs: {
                title: 'About Us',
                item: [
                    {
                        path: '/aboutUs',
                        name: 'About Us'
                    }
                ]
            },
            contactUs: {
                title: 'Contact Us',
                item: [
                    {
                        path: '/contactUs',
                        name: 'Contact Us'
                    }
                ]
            },
            companyInfo: {
                title: 'Company Information',
                item: [
                    'Email Address：lc@lcodin.com',
                    'Telephone Number：008618666465246',
                    'Company Address：1206 R AND D BUILDING2 YANXIANG INDUSTRIAL PARK,HIGH-TECH RD,GUANGMING,SHENZHEN,CHINA'
                ],
            }
        }
    },
    aboutUs: {
        articleTitle: 'Global household electrical appliance motor manufacturer',
        articleContentList: [
            {
                h2Title: '',
                introduce: [
                    `Odin is famous for its series motors and induction motors. Odin is located in Shenzhen, China. For more than 20 years, we have been one of the leading exporters of high-quality motors. After all these years of development, we have become a mature motor manufacturer with a complete production process`
                ]
            },
            {
                h2Title: 'About Odin',
                introduce: [
                    `Odin Import and Export Co., Ltd. is a professional motor manufacturer integrating R&D, production and sales, dedicated to providing customers with various motor products and services. At present, the company focuses on the production of micro DC motors and AC series motors. The products are widely used in household appliances, power tools, medical equipment, general equipment, office equipment and automation equipment. The product quality is stable and consistent, and the performance indicators meet international standards. The products are sold all over the world and are well received by domestic and foreign users. We will continue to pursue technological progress, strive for excellent quality and service first.`,
                    `The purpose we have always adhered to: high quality is our pursuit, customer satisfaction is our commitment!`
                ]
            },
        ],
        illustration: [
            {
                image: companyImage2,
                tips: 'We have intelligent production equipment, combined with a strict quality management system, to ensure the excellent quality and stability of our products from raw materials to finished products.'
            },
            {
                image: companyImage3,
                tips: 'The picture shows our quality inspection process and core component production line. Each process is carefully designed and strictly controlled by professional engineers, which is a solid guarantee for us to fulfill our quality commitment to customers.'
            }
        ]
    },
    contactUs: {
        title: 'Contact Us',
        contentList: [
            {
                h2Title: {
                    before: 'Head Office',
                    after: 'SHEN ZHEN ODIN IMPORT AND EXPORT CO,LTD',
                },
                contactDetail: [
                    'Address：1206 R AND D BUILDING2 YANXIANG INDUSTRIAL PARK,HIGH-TECH RD,GUANGMING,SHENZHEN,CHINA',
                    'Telephone：18666465246',
                    'Email: lc@lcodin.com',
                    'Mobile: 0086-18666465246',
                    'WhatsApp: 86-18666465246',
                    'Website: www.lcodin.com',
                ]
            }
        ]
    },
    newsDetails: {
        views: 'Views',
        author: 'Author',
        createTime: 'Release time',
    },
    products: {
        hotSales: 'hot-sale product',
        lookMoreText: 'View more',
        noProduct: 'There is no corresponding product',
        describe: 'description'
    }
}

export default En